import { AxiosInstance } from 'axios';
import Vue from "vue";

export let _axiosInstance: AxiosInstance;
export const set$axiosInstance = (appAxiosInstance: any) => {
  if (!appAxiosInstance) throw new Error('There is no HTTP client');
  _axiosInstance = appAxiosInstance;
  Vue.prototype.$axiosInstance = _axiosInstance; // для Vue
};




// WEBPACK FOOTER //
// ./src/tools/declare/global/$axiosInstance.ts